import { render, staticRenderFns } from "./EscrowAccount.vue?vue&type=template&id=1bc7513e&scoped=true&"
import script from "./EscrowAccount.vue?vue&type=script&lang=js&"
export * from "./EscrowAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc7513e",
  null
  
)

export default component.exports